import { useContext } from 'react';
import SpinnerIcon from '@pelckmans/elementis/icons/spinner';
import { ExerciseTranslationsContext } from '../contexts/ExerciseTranslationsContext';

export function ExerciseCalculating() {
  const translations = useContext(ExerciseTranslationsContext);

  return (
    <div className="exercise-container" data-testid="exercise-calculating">
      <div className="content">
        <SpinnerIcon data-testid="spinner" className="loading-icon" size="xl" />
        <div className="body">
          <h1 className="title">{translations.exerciseCalculating.title}</h1>
          <div>
            <p>{translations.exerciseCalculating.p1}</p>
            <p>{translations.exerciseCalculating.p2}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
